import { Link } from '@liveauctioneers/hammer-ui-core/link';

import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { getHowTimedAuctionsWorkUrl } from '@/utils/urls';

export const CatalogDetailsZoneTimedPlusLink = () => {
    const formatMessage = useAppFormatMessage();

    return (
        <Link
            className="text-link-secondary"
            href={getHowTimedAuctionsWorkUrl()}
            rel="noopener"
            size="sm"
            target="_blank"
        >
            {formatMessage(['catalogPage', 'catalogStatus', 'aboutTimedPlus'])}
        </Link>
    );
};
